import React from "react";
import { useBrand } from "../branding/BrandContext";
import ProjectCard from "./ProjectCard";
import ServiceProviderCTA from "./ServiceProviderCTA";
import LatestReportBadge from "./LatestReportBadge";

export default function Projects({ projects }) {
  const brand = useBrand();

  return (
    <section className="projects">
      <div className="container">
        

        {/* NEW: 3-column layout */}
        <div className="projectsLayout">
          
          <div className="projectsMain">
            <div className="homepageLatestReportBadgeWrap homepageLatestReportBadgeWrap--sectionTop">
              <LatestReportBadge placement="home_projects" />
            </div>
            <p className="projectsTitle">
              {brand.consumerProjectsHeading || "Home Improvement Projects"}
            </p>
            {/* LEFT: Project cards (2 columns) */}
            <div className="projectsGrid projectsGrid--twoCol">
              
              {projects.map((p) => (
                <ProjectCard
                  key={p.key}
                  icon={p.icon}
                  title={p.label}
                  slug={p.slug}
                />
              ))}
            </div>
          </div>
          {/* RIGHT: Cross-site link, property report, and provider lookup */}
          <div className="projectsSidebar">
            <ServiceProviderCTA />
          </div>

        </div>
      </div>
    </section>
  );
}
